/**
 * Registra los callbacks de auth en supabaseAuthSession para evitar
 * imports dinámicos (await import) que generan require cycles detectados
 * por Madge.
 *
 * Antes, supabaseAuthSession usaba `await import('../../auth/application/authSession')`
 * y `await import('../../auth/public-api')` dentro de refreshSupabaseSessionAndSyncStore.
 * Eso creaba el ciclo: supabaseClient → supabaseAuthSession → authSession → ... → supabaseClient.
 *
 * Ahora los callbacks se inyectan desde acá, rompiendo el ciclo.
 */
import { bindAuthCallbacks } from '../shared/supabase/supabaseAuthSession';
import { logout } from '../auth/application/authSession';
import { useAuthStore } from '../auth/store/useAuthStore';

bindAuthCallbacks({
  onSessionInvalidLogout: (reason) => void logout(reason),
  onSessionRefreshed: (session, user) => useAuthStore.getState().setSession(session, user),
});
